<template>
  <div id="app">
    <div class="sticky top-0 z-10 h75"  v-if="$route.name!='manylessonDetail'">
      <!-- 头部区域s -->
    <div class="header">
     <div class="main">
       <!-- logo区域s -->
       <div class="logo">
         <a href="javascript:void(0)"><img :src="logo" alt=""></a>
       </div>
       <!-- logo区域e -->
      <!-- banner区域s -->
      <div class="banner">
        <el-menu :default-active="$route.path" router class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item v-for="(item,i) in navList" :key="i" :index="item.name">
              <template slot="title">
                <a>{{item.navItem}}</a>
              </template>
            </el-menu-item>
        </el-menu>
      </div>
      <!-- banner区域e -->
      <!-- 功能区s -->
      <div class="actionBar">
        <!-- <input type="text" placeholder="请输入你搜索的内容" :class="inputShow?'searchDisplayInput':'searchInput'"/> -->
        <!-- <img src="@/assets/images/search.png" @click="toSearch" class="search"/>   -->
        <el-input
          placeholder="搜索"
          class="searchBar"
          v-model="input4" @command="handleCommand">
            <a-popover trigger="click"  slot="prefix">
              <template slot="content">
                <p class="cursor-pointer mb-7" @click="searchType=0">课程</p>
                <p class="cursor-pointer" @click="searchType=1">知识库</p>
              </template>
              <a href="javascript:void(0)" class="activeClass" >{{searchType==0?'课程':'知识库'}}<a-icon type="down" v-if="searchType==0"/> <a-icon type="down" v-else/></a>
            </a-popover>
          <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
      </div>
      <!-- 功能区e -->
      <!-- 用户登录区域s -->
     <el-popover
        v-if="ucShow"
        placement="top-end"
        trigger="hover">
        <div class="userLogin" slot="reference">
         <img :src="portrait" class="user"/>
         <p class="phone">{{username}}</p>
        </div>
        <div class="userPovr">
          <p class="toUserCenter" @click="toUserCenter">个人中心</p>
          <p @click="logoOut">退出</p>
        </div>
      </el-popover>
      <!-- <a href="javascript:void(0)" v-else class="to_login">登录</a> -->
      <!-- 用户登录区域e-->
       <button class="toHTBtn" @click="toHTADMIN" v-if="is_admin==1">管理后台</button>
     </div>
    </div>
      <!-- 头部区域e -->
    </div>
    <router-view :style="{minHeight:minHeight+'px'}" :pic="portrait" @changePic="picChange" ref="content" ></router-view>
    <!-- 尾部区域s -->
    <div class="footer">
      <div class="main_foot">
        <p>{{swiperArr.copyright}} </p>
      </div>
    </div>
    <!-- 尾部区域e -->
  </div>
</template>

<script>
import {localStorageCache} from '@/assets/js/utils'
export default {
  name: 'App',
   data(){
    return{
      inputShow:false,
      navList:[ 
        {name:'/',navItem:'首页'},
        {name:'/knowledgeBase/knowledge',navItem:'知识库'},
        {name:'/lesson/lessonMore',navItem:'课程中心'},
        {name:'/news/newSlist',navItem:'最新资讯'}
      ],
       activeIndex: '1',
       username:'',//用户名
       portrait:'',//头像
       input4:'',//搜索的内容
       ucShow:false,//'控制个人中心框可见性'
       headers:{token:'',dataType: "json"},//token
       is_admin:0,// 默认是否是管理员
       swiperArr:{},//logo+foot.
       log:'',//logo
       minHeight:0,
       searchType:0,//默认搜索的是课程
    }
  },
    methods:{
      handleCommand(command){
            this.custom = command.desc;
      },
      async getLBT(){
      this.$http.get('index.php/user/internal/colleges').then((res)=>{
          this.swiperArr=res.data
          this.logo=res.data.logo
      })
    },
      toHTADMIN(){//判断用户是不是管理员
        window.location.href=`index.php/college/framework/auth?token=${this.headers.token}`
      },
      picChange(data){//改变头像(子组件)
        this.portrait=data
      },
      search(){//搜索
      if(this.searchType==0){//课程
        this.$router.push('/lesson/lessonMore')
      }else{//知识库
        this.$router.push('/knowledgeBase/knowledge')
      }
        this.$store.commit('getSearchInput',this.input4)
        console.log(this.input4,'this.input4this.input4this.input4this.input4')
      },
      getUserInfo(){
        // 返回的对象是promise
         this.$http.get('index.php/user/internal/info').then((res)=>{
          this.portrait=res.data.portrait
          this.username=res.data.name
          this.is_admin=res.data.is_admin
        })
        if (!localStorageCache.fetch('token')) { 
             this.ucShow=false
         }else{
           this.ucShow=true
         }
      },
      toSearch(){// 点击搜索按钮
        this.inputShow=!this.inputShow
      },
      logoOut(){// 点击退出登录
      this.$router.push({ path: '/' })
      localStorageCache.remove('token')
      this.ucShow=false
      window.history.go(0)
       
      },
      handleSelect() {// 头部导航栏切换时
      },
      toUserCenter(){//点击个人中心
        this.$router.push(`/userCenter`)
      },
  },
  created(){
    this.headers.token = localStorageCache.fetch('token')
    this.getUserInfo()
    this.getLBT()
  },
  components: {
  },
  mounted(){
    this.minHeight=document.documentElement.clientHeight-100
    var that=this
    window.onresize=function(){
      that.minHeight=document.documentElement.clientHeight-170
    }
  }
}
</script>

<style scoped>
.el-input__icon{
  line-height: 37px;
}
/deep/.actionBar{
  width:210px;
}
/deep/.actionBar .el-input__inner{
  padding-left:85px;
  border-color: #1890ff;
}
/deep/.actionBar.el-input--suffix .el-input__inner {
  padding-right: 0px;
}
/deep/.actionBar .el-input__prefix{
  width: 70px;
  line-height: 34px;
  border-right: 1px solid #1890ff;
  padding: 0px 5px;
}
.activeClass{
  color: #1890ff;
}
/deep/.anticon{
  margin-left: 3px;
  vertical-align: 0.05rem;
}
.logo{
  width: 180px;
  height: 40px;
}

.logo img{
  height: 100%;
  width: 100%;
  min-width:180px;
}

.toHTBtn{
  margin-left: 15px;
  width:70px;
  height: 30px;
  color: #fff;
  background: linear-gradient(to right, #004af2 ,rgba(0, 127, 255));
  border-radius: 3px;
}

.to_login{
  margin-left: 30px;
}

button:focus{
  outline: none;
}

#app{
  background-color: #f7f7f7;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu::after{
  display: none;
}

.search{
  z-index: 1000;
}

.warning{
  margin-bottom: 3px;
}

.searchInput{
  display: none;
}

.searchDisplayInput{
  position: absolute;
  left: 1035px;
  top: 20px;
  border-radius: 10px;
  border: 1px solid #ccc;
  height: 36px;
  padding-left: 10px;
}

li{
  list-style: none;
}
a{
  text-decoration: none;
  color:#000;
}
.clear{
  content: '';
  clear: both;
}
body{
  background-color: #f7f7f7;
  padding-top:75px;
}
.header{
  z-index: 10;
  width:100%;
  height:75px;
  background-color:#fff;
  position: fixed;
  top:0px;
  left:0px;
  box-shadow: 1px 2px 10px rgba(0,0,0,.1);
}
.main{
  align-items: center;
  display: flex;
  width:1200px;
  height: 100%;
  margin:0 auto;
}
.banner>ul{
  width:575px;
  padding-left:105px;
}
.banner>ul li{
  float: left;
  list-style: none;
  margin-right:25px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}
.banner li:hover{
  border-bottom: 2px solid #5173f5;
}
.banner a{
  font-size:16px;
}
.banner li:hover a{
  color: #5173f5;
}
.banner .active{
  color: #5173f5;
  border-bottom: 2px solid #5173f5;
}
.banner .active a{
  color: #5173f5;
}
.actionBar .warning{
  margin-left:20px;
}
.userLogin{
  display: flex;
  align-items: center;
  margin-left:30PX;
}
.userLogin .user{
  width:30px;
  height:30px;
  border-radius: 50%;
}
.userLogin .phone{
  margin-left:10px;
  width: 70px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.userPovr{
  height:95px;
}
.userPovr p{
  cursor: pointer;
    height: 50%;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
}
.toUserCenter{
  border-bottom: 1px solid #ccc;
}
.main_foot{
  align-items: center;
  display: flex;
  width:1200px;
  height: 100%;
  margin:0 auto;
}
.footer{
  width:100%;
  height:100px;
  background-color: #1c1e37;
  bottom: 0px;
  /* position: fixed; */
}
.footer p{ 
  margin: 0 auto;
  color:#b2b6b6;
  font-size:12px;
}
.searchBar ::v-deep.el-input__inner{
  height:34px;
}
.h75{
  height: 75px;
}
</style>